import React from 'react';

import SvgIcon from './icon.svg';

const Icon = ({ classes, ...rest }) => (
  <SvgIcon className={classes.icon} {...rest} />
);

export default Icon;
